export default {
    ON_USER_REGISTRATION: "ON_USER_REGISTRATION",
    ON_USER_ROUTE_SELECT: "ON_USER_ROUTE_SELECT",
    ON_USER_LOGOUT:"ON_USER_LOGOUT"
}